import styled from '@emotion/styled';
import { css } from '@emotion/core';

import COLORS from '$variables/colors';
import { spacing } from '$variables/theme';

const styles = css`
  height: 32px;
  width: 66px;
  text-decoration: none;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
`;

export const Link = styled.a`
  ${styles}

  cursor: ${({ disabled }) => (disabled ? 'progress' : 'pointer')};
  background-color: ${COLORS.purplishBlue};
  color: ${({ look }) => look.color};
`;

export const DisabledLink = styled.div`
  ${styles}

  cursor: not-allowed;
  background-color: ${COLORS.grey6};
  color: ${COLORS.white};
`;

export const Container = styled.div`
  margin-top: ${spacing.xLarge};
  display: flex;
  flex-direction: column;
  gap: ${spacing.small};
  align-items: center;
`;
